import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { registerLocaleData } from '@angular/common';
import * as fr from '@angular/common/locales/fr';
import { environment } from './environments/environment';

console.log(environment.version);

registerLocaleData(fr.default);
bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
